// extracted by mini-css-extract-plugin
export default {"tabs":"ShapeKeyLegendCard_tabs__Lqsf4","tabsContainer":"ShapeKeyLegendCard_tabsContainer__HhWwy"};